module.exports = fox._r("images/social3.png", __webpack_public_path__ + "images/social3.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/social3.png
// module id = 1126
// module chunks = 4